import { getContext } from '@fiverr-private/fiverr_context';

const redirect = (url) => {
    window.location.assign(url);
};

const getUsernamePathParam = () => {
    const { pathParameters } = getContext();
    const { username } = pathParameters;

    return username;
};

const getConversationUrl = (pathfinderWrapper) => {
    const username = getUsernamePathParam();
    return pathfinderWrapper.pathfinder('conversation', { id: username });
};

const redirectToInboxConversation = (pathfinderWrapper) => {
    const inboxConversationUrl = getConversationUrl(pathfinderWrapper);
    redirect(inboxConversationUrl);
};

export {
    getConversationUrl,
    redirectToInboxConversation
};
